import axios from 'axios';
import API from '../config/api';
import { resHandle } from '../helper';



export const creditsListService = params => axios.get(API.CREDITS_LIST + params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});


export const creditsCreateService = params => axios.post(API.CREATE_CREDITS, params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});

export const creditsDeleteService = params => axios.post(API.DELETE_CREDITS, params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});

export const creditsUpdateService = params => axios.post(API.UPDATE_MODULE_CREDITS, params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});


